// extracted by mini-css-extract-plugin
export default {"indentList":"un67YZZY","subTitle":"UUnStjGx"};